// Channels eligible as warehouse sources (operator hand-adds via the
// quick-add page; the price worklist reads the same set). Mirrors
// migrations 0056 + 0059 + 0062. New stores: append here + create the
// channel via migration. Order: most-used first (Costco weekly run on
// top, with its consumable sub-channels grouped under it).
//
// Lives in its own module so both WarehouseQuickAddPage and
// WarehousePriceWorklist can import it without a circular dependency.
export const WAREHOUSE_CHANNELS = [
  { slug: "costco-vitamins",       label: "Costco · Vitamins",       register: "spec" },
  { slug: "costco-food",           label: "Costco · Food",           register: "spec" },
  { slug: "costco-personal-care",  label: "Costco · Personal Care",  register: "spec" },
  { slug: "costco-home",           label: "Costco · Home & More",    register: "spec" },
  { slug: "bjs-wholesale",         label: "BJ's Wholesale",       register: "spec" },
  { slug: "sams-club",             label: "Sam's Club",           register: "spec" },
  { slug: "trader-joes",           label: "Trader Joe's",         register: "spec" },
  { slug: "ross",                  label: "Ross",                 register: "editorial" },
  { slug: "marshalls",             label: "Marshalls",            register: "editorial" },
  { slug: "tj-maxx",               label: "TJ Maxx",              register: "editorial" },
  { slug: "burlington",            label: "Burlington",           register: "editorial" },
  { slug: "lacoste-outlet",        label: "Lacoste Outlet",       register: "editorial" },
  { slug: "michael-kors-outlet",   label: "Michael Kors Outlet",  register: "editorial" },
];
